<template>
	<div class="flex-wrapper">
		<TypographyTitle :level="2" class="flex-grow">
			{{ $t('account.header') }}
		</TypographyTitle>
		<Button @click="onLogout">
			<LogoutOutlined /> {{ $t('account.logoutButtonLabel') }}
		</Button>
	</div>
	<ChangePasswordForm />
</template>

<script>
import { TypographyTitle, Button } from 'ant-design-vue';
import { LogoutOutlined } from '@ant-design/icons-vue';

import ChangePasswordForm from '@/components/account/ChangePasswordForm';

import { useLogout } from '@/components/account/useLogout';

export default {
	components: {
		TypographyTitle, Button, ChangePasswordForm, LogoutOutlined,
	},
	setup() {
		const { onLogout } = useLogout();
		return {
			onLogout,
		};
	}
}
</script>
